import { render, staticRenderFns } from "./testPaperCenter.vue?vue&type=template&id=058b5dfa&scoped=true"
import script from "./testPaperCenter.vue?vue&type=script&lang=js"
export * from "./testPaperCenter.vue?vue&type=script&lang=js"
import style0 from "./testPaperCenter.vue?vue&type=style&index=0&id=058b5dfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058b5dfa",
  null
  
)

export default component.exports